import React, { useState, useEffect } from 'react';
import './OpeningExperience.css';

interface Props {
  onComplete?: () => void;
}

export const OpeningExperience: React.FC<Props> = ({ onComplete }) => {
  const [phase, setPhase] = useState<'INITIAL' | 'SETTLED' | 'LEAVING' | 'DONE'>('INITIAL');

  useEffect(() => {
    // Check if user has visited in this session
    const hasVisited = sessionStorage.getItem('nashgo_app_opened');
    const isReturning = Boolean(hasVisited);

    // Duration strategy per Phase 3 specs (1.2-2.0s first time, 350-500ms returning)
    const settleDuration = isReturning ? 350 : 1200;
    const leaveDuration = isReturning ? 200 : 400;

    const settleTimer = setTimeout(() => {
      setPhase('SETTLED');
    }, settleDuration * 0.4);

    const leaveTimer = setTimeout(() => {
      setPhase('LEAVING');
    }, settleDuration);

    const doneTimer = setTimeout(() => {
      setPhase('DONE');
      sessionStorage.setItem('nashgo_app_opened', 'true');
      if (onComplete) onComplete();
    }, settleDuration + leaveDuration);

    return () => {
      clearTimeout(settleTimer);
      clearTimeout(leaveTimer);
      clearTimeout(doneTimer);
    };
  }, [onComplete]);

  if (phase === 'DONE') return null;

  return (
    <div
      className={`opening-screen-overlay ${phase === 'LEAVING' ? 'fade-out' : ''}`}
      aria-hidden="true"
      dir="rtl"
    >
      <div className="opening-center-content">
        <div className="opening-logo-wrapper">
          <div className="opening-logo-badge">
            <img src="/oto-logo.jpg" alt="OTO STUDENTS" className="opening-logo-img" />
            <div className="logo-pulse-ring"></div>
          </div>
        </div>

        <div className="opening-text-group">
          <h1 className="opening-brand-name">
            <span className="brand-accent">OTO</span> STUDENTS
          </h1>
          <p className="opening-tagline">اوتو ستيودنتس — سفرك للجامعة أسهل، أسرع، وأأمن</p>
        </div>

        <div className="opening-route-track">
          <div className="opening-route-line"></div>
          <div className="opening-route-car"></div>
          <div className="opening-route-dots">
            <span className="dot dot-origin">الإسكندرية</span>
            <span className="dot dot-dest">الجامعات المصرية</span>
          </div>
        </div>
      </div>
    </div>
  );
};
